export const INIT_MY_PAGE = 'INIT_MY_PAGE';
